import accounting from "@/api/report/accounting";
import { baseState, baseMutations } from "@/store/mixins";
import { join } from "lodash";
export const state = {
    ...baseState
};

export const getters = {};

export const mutations = {
    ...baseMutations
};

export const actions = {
    // generate profit and loss
    profitAndLoss(context, attributes = {}) {
        return accounting.profitAndLoss({
            params: Object.assign(
                {
                    template: localStorage.getItem("langCode")
                        ? localStorage.getItem("langCode")
                        : "en"
                },
                attributes
            )
        });
    },
    // generate summary of active account
    summaryOfActiveAccount(context, attributes = {}) {
        return accounting.summaryOfActiveAccount({
            params: Object.assign(
                {
                    template: localStorage.getItem("langCode")
                        ? localStorage.getItem("langCode")
                        : "en"
                },
                attributes
            )
        });
    },
    // generate trial balance
    trialBalance(context, attributes = {}) {
        return accounting.trialBalance({
            params: Object.assign(
                {
                    template: localStorage.getItem("langCode")
                        ? localStorage.getItem("langCode")
                        : "en"
                },
                attributes
            )
        });
    },
    // generate balance sheet
    balanceSheet(context, attributes = {}) {
        return accounting.balanceSheet({
            params: Object.assign(
                {
                    template: localStorage.getItem("langCode")
                        ? localStorage.getItem("langCode")
                        : "en"
                },
                attributes
            )
        });
    },
    // generate general journal record
    generalJournalRecord(context, attributes = {}) {
        return accounting.generalJournalRecord({
            params: Object.assign(
                {
                    template: localStorage.getItem("langCode")
                        ? localStorage.getItem("langCode")
                        : "en",
                    filter: {
                        date_between: join(attributes.dateRange, ","),
                        currency_id: attributes.currency_id
                    }
                },
                attributes
            )
        });
    },
    // generate general ledger
    generalLedger(context, attributes = {}) {
        return accounting.generalLedger({
            params: Object.assign(
                {
                    template: localStorage.getItem("langCode")
                        ? localStorage.getItem("langCode")
                        : "en"
                },
                attributes
            )
        });
    },
    generalLedgerExportExcel(context, { ...attributes }) {
        return accounting.generalLedgerExportExcel(
            Object.assign(
                {
                    template: localStorage.getItem("langCode")
                        ? localStorage.getItem("langCode")
                        : "en"
                },
                attributes
            )
        );
    },
    generalJournalRecordExportExcel(context, { ...attributes }) {
        return accounting.generalJournalRecordExportExcel(
            Object.assign(
                {
                    template: localStorage.getItem("langCode")
                        ? localStorage.getItem("langCode")
                        : "en",
                    filter: {
                        date_between: join(attributes.dateRange, ","),
                        currency_id: attributes.currency_id
                    }
                },
                attributes
            )
        );
    },
    // v3 — General Ledger
    generalLedgerV3(context, attributes = {}) {
        return accounting.generalLedgerV3({
            params: Object.assign(
                { template: localStorage.getItem("langCode") },
                attributes
            )
        });
    },
    generalLedgerV3ExportExcel(context, attributes = {}) {
        return accounting.generalLedgerV3ExportExcel(
            Object.assign(
                { template: localStorage.getItem("langCode") },
                attributes
            )
        );
    },
    // v3 — General Journal Record
    generalJournalRecordV3(context, attributes = {}) {
        return accounting.generalJournalRecordV3({
            params: Object.assign(
                { template: localStorage.getItem("langCode") },
                attributes
            )
        });
    },
    generalJournalRecordV3ExportExcel(context, attributes = {}) {
        return accounting.generalJournalRecordV3ExportExcel(
            Object.assign(
                { template: localStorage.getItem("langCode") },
                attributes
            )
        );
    },
    generalJournalRecordV3ExportPdf(context, attributes = {}) {
        return accounting.generalJournalRecordV3ExportPdf(
            Object.assign(
                { template: localStorage.getItem("langCode") },
                attributes
            )
        );
    },
    trialBalanceExportExcel(context, { ...attributes }) {
        return accounting.trialBalanceExportExcel(
            Object.assign(
                {
                    template: localStorage.getItem("langCode")
                        ? localStorage.getItem("langCode")
                        : "en"
                },
                attributes
            )
        );
    },
    // v3 — Trial Balance (paginated JSON for the web table)
    trialBalanceV3(context, attributes = {}) {
        return accounting.trialBalanceV3({
            params: Object.assign(
                { template: localStorage.getItem("langCode") || "en" },
                attributes
            )
        });
    },
    trialBalanceV3ExportExcel(context, attributes = {}) {
        return accounting.trialBalanceV3ExportExcel(
            Object.assign(
                { template: localStorage.getItem("langCode") || "en" },
                attributes
            )
        );
    },
    trialBalanceV3ExportPdf(context, attributes = {}) {
        return accounting.trialBalanceV3ExportPdf(
            Object.assign(
                { template: localStorage.getItem("langCode") || "en" },
                attributes
            )
        );
    },
    balanceSheetExportExcel(context, { ...attributes }) {
        return accounting.balanceSheetExportExcel(
            Object.assign(
                {
                    template: localStorage.getItem("langCode")
                        ? localStorage.getItem("langCode")
                        : "en"
                },
                attributes
            )
        );
    },
    // v3 — Balance Sheet (paginated JSON for the web table)
    balanceSheetV3(context, attributes = {}) {
        return accounting.balanceSheetV3({
            params: Object.assign(
                { template: localStorage.getItem("langCode") || "en" },
                attributes
            )
        });
    },
    balanceSheetV3ExportExcel(context, attributes = {}) {
        return accounting.balanceSheetV3ExportExcel(
            Object.assign(
                { template: localStorage.getItem("langCode") || "en" },
                attributes
            )
        );
    },
    balanceSheetV3ExportPdf(context, attributes = {}) {
        return accounting.balanceSheetV3ExportPdf(
            Object.assign(
                { template: localStorage.getItem("langCode") || "en" },
                attributes
            )
        );
    },
    profitAndLossExportExcel(context, { ...attributes }) {
        return accounting.profitAndLossExportExcel(
            Object.assign(
                {
                    template: localStorage.getItem("langCode")
                        ? localStorage.getItem("langCode")
                        : "en"
                },
                attributes
            )
        );
    },
    // v3 — Profit and Loss (paginated JSON for the web table)
    profitAndLossV3(context, attributes = {}) {
        return accounting.profitAndLossV3({
            params: Object.assign(
                { template: localStorage.getItem("langCode") || "en" },
                attributes
            )
        });
    },
    profitAndLossV3ExportExcel(context, attributes = {}) {
        return accounting.profitAndLossV3ExportExcel(
            Object.assign(
                { template: localStorage.getItem("langCode") || "en" },
                attributes
            )
        );
    },
    profitAndLossV3ExportPdf(context, attributes = {}) {
        return accounting.profitAndLossV3ExportPdf(
            Object.assign(
                { template: localStorage.getItem("langCode") || "en" },
                attributes
            )
        );
    },
    summaryOfActiveAccountExportExcel(context, { ...attributes }) {
        return accounting.summaryOfActiveAccountExportExcel(
            Object.assign(
                {
                    template: localStorage.getItem("langCode")
                        ? localStorage.getItem("langCode")
                        : "en"
                },
                attributes
            )
        );
    },
    summaryOfActiveAccountRawDataCSV(context, { ...attributes }) {
        return accounting.summaryOfActiveAccountRawDataCSV(
            Object.assign(
                {
                    template: localStorage.getItem("langCode")
                        ? localStorage.getItem("langCode")
                        : "en"
                },
                attributes
            )
        );
    }
};
